import React from 'react';

import {useI18n} from '@udemy/i18n';
import {Button} from '@udemy/react-core-components';

import {AT_RISK_STEP_ID, STEP_PROGRESS} from '../constants';
import {AT_RISK_HELP_CTA} from '../events';
import {StepLayout} from '../step-layout.react-component';
import styles from './response-step.module.less';

import type {StepRendererProps} from '../types';

export function ConfirmationStep({onClose, onTrackEventClick}: StepRendererProps) {
    const {gettext} = useI18n();

    return (
        <StepLayout
            progressValue={STEP_PROGRESS[AT_RISK_STEP_ID.CONFIRMATION]}
            onClose={onClose}
            footerRightChildren={
                <Button
                    udStyle="primary"
                    size="medium"
                    onClick={() => {
                        onTrackEventClick(AT_RISK_HELP_CTA.DONE);
                        onClose();
                    }}
                >
                    {gettext('Close')}
                </Button>
            }
        >
            <div className={styles['content']}>
                <h2 className="ud-heading-xl">{gettext('Thank you for your feedback.')}</h2>
                <p className="ud-text-md">
                    {gettext(
                        "We genuinely appreciate you sharing what's on your mind. It helps us build a better experience for everyone.",
                    )}
                </p>
            </div>
        </StepLayout>
    );
}
